import { productCategories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            Product Categories
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            AllChinaBuy Spreadsheet Categories
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-xl mx-auto">
            Browse all 14 product categories from our verified AllChinaBuy Spreadsheet. Click any category to explore products on the main site.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {productCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="w-full h-32 md:h-36 overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2 px-3 py-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className="ri-shopping-bag-3-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}